import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';

@Component({
    selector: 'app-edit-camion',
    templateUrl: './edit-camion.component.html',
    styleUrls: ['./edit-camion.component.css'],
    standalone: false
})
export class EditCamionComponent implements OnInit {

  form: UntypedFormGroup;
  marca: string = "";
  modelo: string = "";
  matricula: string = "";
  activo: boolean = true;

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EditCamionComponent>) { }

  ngOnInit(): void {
    this.marca = this.data['marca'];
    this.modelo = this.data['modelo'];
    this.matricula = this.data['matricula'];
    this.activo = (this.data['activo'] == 'true');
    this.form = this.fb.group({
      marca: [this.marca, [Validators.maxLength(64)]],
      modelo: [this.modelo, [Validators.maxLength(64)]],
      matricula: [this.matricula, [Validators.required, Validators.minLength(1), Validators.maxLength(16)]],
      activo: [this.activo, [Validators.required]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
